import { api } from 'constants/api';

import { useMutation } from '@tanstack/react-query';
import { MutationOptions } from 'types/utils/mutation-options';
import { ApiResponse } from 'types/utils/api-response';
import { AudienceType } from 'types/create-campaign';

type Response = AudienceType;

type Params = unknown;

export const useCreateNewAudience = (
  options: MutationOptions<Response, Params>
) =>
  useMutation({
    mutationFn: async (params) => {
      const { data } = await api.post<ApiResponse<Response>>(
        `/audience`,
        params
      );

      return data.data;
    },
    ...options,
  });
